import React, { Component, createRef } from "react";
import { imsLoader, robotHeadChatgpt, iconiMSAuthoring, expandAllBlueIcon, globalExpandAllIcon } from '../../assets/index';
import axios from "axios";
import NotebookListPopUp from "../PopUp/NotebookListPopUp";
import CommandListPopUp from "../PopUp/CommandListPopUp";
import { LocationOrigin, WordsMaxLength } from "../../utils/utilityServices";
import { v4 as uuidv4 } from 'uuid';
import './AuthoringSummery.css'
import './AuthoringGPT.css';
import moment from "moment";
import Dropzone from 'react-dropzone';
import ExpandContentPopUpModal from '../PopUp/ExpandContentPopUpModal';
import ExpandAllFieldsContentPopUpModal from '../PopUp/ExpandAllFieldsContentPopUpModal';
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import trackingService from "../../services/trackingService";
import NotebookListPopUpGlobal from "../PopUp/NotebookListPopUpGlobal";
import SuccessReadingList from "../PopUp/SucessReadingList";
import ApiServices from "../../utils/apiServices";
import { isEmptyObject } from "jquery";
import { Modal } from "react-bootstrap";
import ConfirmMessagePopUpModal from "./../PopUp/ConfirmMessagePopUpModal"
import ReactDataSheet from 'react-datasheet';
import * as XLSX from 'xlsx';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import AuthoringDisclaimer from './AuthoringDisclaimer'
import 'react-tabs/style/react-tabs.css';
// Be sure to include styles at some point, probably during your bootstrapping
import 'react-datasheet/lib/react-datasheet.css';
// import Typewriter from 'typewriter-effect';
import AuthoringUserSummery from "./AuthoringUserSummery"
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
import { Authentication } from "../../utils/authenticationUtilityServices";
const sanitize = DOMPurify.sanitize;

const summarizeResult = 'SummarizeResult';
const userQuestion = 'UserQuestion';
const ShowWordCountForCommandType = ['Translate', 'CreateTable'];
const ExcelFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
const fileTypes = ['application/pdf'];


class AuthoringGPT extends Component {
    constructor(props) {
        super(props);
        this.messagesEndRef = createRef()
        var guid = uuidv4();
        let _showDisclaimerPopup = true;
        let strShowDisclaimerPopup = localStorage.getItem('showGlobalAuthoringDisclaimer');
        if (strShowDisclaimerPopup) {
            _showDisclaimerPopup = !JSON.parse(strShowDisclaimerPopup);
        }
        this.state = {
            isProcessing: false,
            isCitationProcessing: false,
            orignalText: '',
            summarizeText: '',
            lastCommandType: 'UserInstructions',
            showNotebookList: false,
            commandText: '',
            commandType: 'UserInstructions',
            chatConversation: [],
            filestoUpload: [],
            sessionID: guid,
            notesText: '',
            citationText: '',
            expandNotes: false,
            expandCitation: false,
            expandSourceText: false,
            expandAllFields: false,
            expandCommand: false,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            sliderValue: 14,
            savingSummarizeText: '',
            savingCommandType: 'UserInstructions',
            savingOrignalText: '',
            savingCommandText: '',
            showCommandList: false,
            isUserCommand: true,
            isTemplateCommand: false,
            isFromGlobalFeaturesMenu: false,
            isFromGlobalFeaturesMenuForNotebook: false,
            isShowMore: false,
            selectedNotebook: null,
            isNewNotebook: false,
            selectedNotebookName: "",
            successMessage: "",
            showSuccess: false,
            isClickOnSelectNotebook: false,
            uploadFilePlaceHolder: "Upload Document",
            uploadFile: null,
            showPreviewModel: false,
            showPreview: false,
            previewURL: '',
            isFileProcessing: false,
            selectAllText: false,
            isProcessingSelectAllText: false,
            isConfirm: false,
            confirmMessageContent: '',
            confirmMessageShowModal: false,
            confirmMessageIndex: -1,
            isClearAllFields: true,
            previousOrignalText: "",
            excelSheetNames: [],
            selectedExcelSheetName: "",
            excelFileData: {},
            uploadFileType: '',
            tabIndex: 0,
            showPopupLoader: false,
            firstCall: true,
            showDisclaimerPopup: _showDisclaimerPopup,
            allFileContent: ""
        }
    }
    handleOnClickSourceTextExpand = () => {
        this.setState({ expandSourceText: true })
    }
    handleOnClickcommandTextExpand = () => {
        this.setState({ expandCommand: true })
    }
    handleOnClicNotesExpand = () => {
        this.setState({ expandNotes: true })
    }
    handleOnClickCitationExpand = () => {
        this.setState({ expandCitation: true })
    }
    handleOnClickClearCitationExpand = () => {
        this.setState({ citationText: '' }, () => {
            this.successAlertMessage('Citation cleared successfully');
        })
    }
    handleOnClickClearNotesExpand = () => {
        this.setState({ notesText: '' }, () => {
            this.successAlertMessage('Notes cleared successfully');
        })
    }
    handleSourceTextExpand = (orignalText) => {
        this.setState({ orignalText: orignalText, expandSourceText: false })
    }
    handleAllFieldsContentExpand = (orignalText, notesText) => {
        this.setState({ orignalText: orignalText, notesText: notesText, expandAllFields: false })
    }
    handleNotesExpand = (notesText) => {
        this.setState({ notesText: notesText, expandNotes: false })
    }
    handleCommandTextExpand = (commandText) => {
        this.setState({ commandText: commandText, expandCommand: false })
    }
    handleCitationExpand = (citationText) => {
        this.setState({ citationText: citationText, expandCitation: false })
    }
    handleSummery = (e) => {
        this.setState({ orignalText: e.target.value })
    }
    handleChangeCommandType = (e) => {
        this.setState({ commandType: e.target.value });
    };
    handleComment = (e) => {
        this.setState({ commandText: e.target.value })
    }
    handleAddToCommandText = (commandText) => {
        this.setState({ commandText: commandText, showCommandList: false })
    }
    handleNotes = (e) => {
        this.setState({ notesText: e.target.value })
    }
    handleCitation = (e) => {
        this.setState({ citationText: e.target.value })
    }
    handleAddToNotes = (notesText) => {
        notesText = notesText.replace(/<br\/>/g, '\r\n');
        this.setState({ notesText: notesText })
    }
    onDropAccepted = (filestoUpload) => {
        this.fileInputChange(filestoUpload)
    }
    onDropRejected = (filestoUpload) => {
        if (filestoUpload.length) {
            this.errorAlertMessage("You can upload only one file")
        }
    }
    handleAddToNotebook = (summarizeText, commandType, orignalText, commandText) => {
        if (commandType === "Summarize" || commandType === "UserInstructions" || commandType === "Translate" || commandType === "QnA") {
            summarizeText = summarizeText.replace(/<br\/>/g, '\r\n').replace(/&gt;/g, '>').replace(/&lt;/g, '<');
        }

        this.setState({
            savingSummarizeText: summarizeText,
            savingCommandType: commandType,
            savingOrignalText: orignalText,
            savingCommandText: commandText,
            //showNotebookList: true
        }, async () => {
            let { selectedNotebookName } = this.state;
            if (selectedNotebookName) {
                await this.onclickProceed();
            } else {
                this.setState({
                    showNotebookList: true
                });
            }
        })
    }
    handleAddToNotebookPreview = (summarizeText, commandType, orignalText) => {
        if (commandType === "Summarize" || commandType === "UserInstructions") {
            summarizeText = summarizeText.replace(/<br>/g, '\r\n').replace(/<br\/>/g, '\r\n');//.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
        }
        this.setState({
            savingSummarizeText: summarizeText,
            savingCommandType: commandType,
            savingOrignalText: orignalText,
            showNotebookPreviewList: true
        })
    }
    showConfirmMessage = (message) => {
        this.setState({
            confirmMessageContent: message,
            confirmMessageShowModal: true,
        })
    }
    confirmHandler = async () => {
        this.setState(
            {
                confirmMessageContent: "",
                confirmMessageShowModal: false,
                confirmMessageIndex: -1,
                isConfirm: true
            },
            async () => {
                this.onSummeryClick();
            }
        );
    }
    closeConfirmMessage = () => {
        this.setState({
            confirmMessageContent: "",
            confirmMessageShowModal: false,
            confirmMessageIndex: -1
        })
    }
    onclickProceed = async () => {

        let wwid = JSON.parse(localStorage.getItem("wwid"));
        let service = new ApiServices();
        if (this.state.selectedNotebookName) {
            let referencetext = '', _notesText = '';
            let { citationText, notesText } = this.state;
            if (citationText) {
                referencetext = citationText;
            }
            if (notesText) {
                _notesText = notesText;
            }
            let { sourceItem } = this.props;
            let _url = '', _docTitle = ''

            let { savingOrignalText, savingSummarizeText, savingCommandType, savingCommandText, isNewNotebook } = this.state;
            if (isNewNotebook) {
                this.setState({ isProcessing: true })
                let listID = uuidv4();
                let _summeryText = savingOrignalText.split(' ').filter((x, i) => i < 2000).join(' ')
                let _summarizeText = savingCommandType !== 'CreateTable' ? savingSummarizeText : '';
                let _tableSummarizedHtml = savingCommandType === 'CreateTable' ? savingSummarizeText : '';
                await service.insertUpdateNotebookList(
                    wwid,
                    `NL_${listID}`,
                    this.state.selectedNotebookName,
                    _summeryText,
                    _summarizeText,
                    citationText,
                    _notesText,
                    _tableSummarizedHtml,
                    savingCommandType,
                    savingCommandText,
                    _docTitle,
                    _url,
                );

                this.indexDataOnSave(_summeryText, _summarizeText, savingCommandType, `NL_${listID}`, this.state.selectedNotebookName, referencetext, _notesText, _tableSummarizedHtml, sourceItem);
                //console.log("ID:"+`RL_${listID}`+" Name:"+this.state.notebookListName+" Doc ID:"+this.state.docID)
                let objNotebook = {
                    notebooklist_id: `NL_${listID}`,
                    notebooklist_name: this.state.selectedNotebookName
                }
                this.setState({
                    successMessage:
                        "The note was saved successfully to new Notebook.",
                    selectedNotebook: objNotebook,
                    isNewNotebook: false,
                    isProcessing: false,
                });
            } else if (this.state.selectedNotebook) {
                let { selectedNotebook } = this.state;
                this.setState({ isProcessing: true })
                let _summarizeText = savingCommandType !== 'CreateTable' ? savingSummarizeText : '';
                let _tableSummarizedHtml = savingCommandType === 'CreateTable' ? savingSummarizeText : '';
                let _summeryText = savingOrignalText.split(' ').filter((x, i) => i < 2000).join(' ')
                await service.insertUpdateNotebookList(
                    wwid,
                    selectedNotebook.notebooklist_id,
                    selectedNotebook.notebooklist_name,
                    _summeryText,
                    _summarizeText,
                    citationText,
                    _notesText,
                    _tableSummarizedHtml,
                    savingCommandType,
                    savingCommandText,
                    _docTitle,
                    _url,
                );
                this.indexDataOnSave(_summeryText, _summarizeText, savingCommandType, selectedNotebook.notebooklist_id, selectedNotebook.notebooklist_name, citationText, _notesText, _tableSummarizedHtml, sourceItem);
                this.setState({
                    successMessage:
                        "The note was saved successfully to selected existing Notebook(s).",
                    isProcessing: false,
                });
            }
            this.setState({
                showSuccess: true,
                isFromGlobalFeaturesMenuForNotebook: true,
                showNotebookList: true,
            });
        } else {
            let { summarizeText, lastCommandType, orignalText } = this.state;
            this.setState({
                savingSummarizeText: summarizeText,
                savingCommandType: lastCommandType,
                savingOrignalText: orignalText,
                showNotebookList: true
            });
            // this.errorAlertMessage("Notebook name is required, Please select notebook.");
        }
    };
    handleSuccessClose = (status) => {
        this.setState({
            showSuccess: status,
        });
    };
    handleClickOnMyCommand = () => {
        this.setState({
            isUserCommand: true,
            isTemplateCommand: false,
            showCommandList: true,
            isFromGlobalFeaturesMenu: true
        })

    }
    handleClickOnTemplateCommand = () => {
        this.setState({
            isUserCommand: false,
            isTemplateCommand: true,
            showCommandList: true,
            isFromGlobalFeaturesMenu: true
        })

    }
    handleAddToCommand = () => {
        let { commandText } = this.state;
        if (commandText) {
            this.setState({
                showCommandList: true,
                isUserCommand: true,
                isTemplateCommand: false,
                isFromGlobalFeaturesMenu: false
            })
        }
    }
    handleDisclaimerClose = async () => {
        let strShowDisclaimerPopup = localStorage.getItem('showGlobalAuthoringDisclaimer');
        if (strShowDisclaimerPopup && !JSON.parse(strShowDisclaimerPopup)) {
            let service = new ApiServices();
            let wwid = JSON.parse(localStorage.getItem("wwid"));
            await service.UpdateDisclaimerStatus(wwid, 'isshowglobalauthoringdisclaimer', true);
        }
        this.setState({ showDisclaimerPopup: false });
        localStorage.setItem('showGlobalAuthoringDisclaimer', JSON.stringify(true));
    }
    handleAddToConvertCitation = async () => {
        let { citationText, sessionID } = this.state;
        if (citationText) {
            var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_AMA}ama_api2`
            if (window.location.origin === 'https://predev-ims.jnj.com') {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_AMA}ama_api2`
            }
            //url = `https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_NLP_AMA}ama_api2`
            this.setState({ isCitationProcessing: true });
            const _headers = {
                "Content-Type": "application/json"
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "orignalCitation": citationText,
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "sessionID": sessionID,
                    "wwid": JSON.parse(localStorage.getItem('wwid')),
                }
            }
            await axios(config).then((response) => {
                if (response.data.AMACitation) {
                    this.setState({ citationText: response.data.AMACitation })
                    let requestTokenCount = 0, responseTokenCount = 0;
                    if (response.data.requestTokenCount)
                        requestTokenCount = response.data.requestTokenCount;
                    if (response.data.responseTokenCount)
                        responseTokenCount = response.data.responseTokenCount;
                    this.indexDataOnAMA(citationText, response.data.AMACitation, sessionID, requestTokenCount, responseTokenCount);
                }

            }).catch((error) => {
                console.log(error)
            }).finally(() => {
                this.setState({ isCitationProcessing: false });
            });
        }
    }
    indexDataOnSave = (orignaltext, summarizetext, commandtype, notebooklistId, notebooklistName, referencetext, notesText, tableSummarizedHtml, item) => {
        if (!isEmptyObject(item)) {
            let { orderedBy, orderedFor } = item;
            if (!orderedBy) orderedBy = '';
            if (!orderedFor) orderedFor = '';
            let docVersion = '', docNumber = ''
            if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL') {
                docVersion = item.r_version_label;
                docNumber = item.jj_number;
            }
            else if (item.domain === 'SKM') {
                docNumber = item.domain;
            }
            else if (item.domain === 'CTGov') {
                docNumber = item.docID;
            }
            else {
                docVersion = item.majorVersionNumber;
                docNumber = item.documentNumber;
            }
            let url = '';
            if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
                url = `/DocURL?ID=${item.docID}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            }
            else if (item.domain === 'SKM' || item.domain === "MIAs") {
                url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            }
            else {
                url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
                if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                    url = url + `&docState=anr`
                }
            }
            if (item.enclosureDocID) {
                url += `&enclosureID=${item.enclosureDocID}`
            }
            let newUrl = window.origin + url;
            let authoringinfo = {
                "orignaltext": orignaltext,
                "summarizetext": summarizetext,
                "commandtype": commandtype,
                "notebooklistId": notebooklistId,
                "notebooklistName": notebooklistName,
                "referencetext": referencetext,
                "notesText": notesText,
                "tableSummarizedHtml": tableSummarizedHtml
            }
            const ts = new trackingService();
            ts.indexTrackingData(localStorage.getItem('userdisplayName'),
                localStorage.getItem('wwid'),
                localStorage.getItem('username'),
                localStorage.getItem('function'),
                localStorage.getItem('region'),
                localStorage.getItem('userproducts'),
                localStorage.getItem('doctypepref'),
                localStorage.getItem('sid'),
                localStorage.getItem('deviceType'),
                localStorage.getItem('deviceOS'),
                localStorage.getItem('browserName'),
                localStorage.getItem('browserVersion'),
                localStorage.getItem('jnjDepartment'),
                localStorage.getItem('companyname'),
                `Save Notebook`,
                '',
                window.location.href, '', '', item.docTitle, docVersion, docNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, 'Save Notebook', '', '', item.domain, '', '', item.createdDate, orderedBy, orderedFor,
                {}, authoringinfo);
        } else {
            let authoringinfo = {
                "orignaltext": orignaltext,
                "summarizetext": summarizetext,
                "commandtype": commandtype,
                "notebooklistId": notebooklistId,
                "notebooklistName": notebooklistName,
                "referencetext": referencetext,
                "notesText": notesText,
                "tableSummarizedHtml": tableSummarizedHtml
            }
            const ts = new trackingService();
            ts.indexTrackingData(localStorage.getItem('userdisplayName'),
                localStorage.getItem('wwid'),
                localStorage.getItem('username'),
                localStorage.getItem('function'),
                localStorage.getItem('region'),
                localStorage.getItem('userproducts'),
                localStorage.getItem('doctypepref'),
                localStorage.getItem('sid'),
                localStorage.getItem('deviceType'),
                localStorage.getItem('deviceOS'),
                localStorage.getItem('browserName'),
                localStorage.getItem('browserVersion'),
                localStorage.getItem('jnjDepartment'),
                localStorage.getItem('companyname'),
                `Save Notebook`,
                '',
                window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
                {}, authoringinfo);
        }

    }
    indexData = (orignaltext, summarizetext, commandtext, commandtype, previousSummarizeText, sessionid, requestTokenCount, responseTokenCount, multiCommands, answersList) => {

        let authoringinfo = {
            "orignaltext": orignaltext,
            "summarizetext": summarizetext,
            "commandtext": commandtext,
            "commandtype": commandtype,
            "sessionid": sessionid,
            "previousSummarizeText": previousSummarizeText,
            "requestTokenCount": requestTokenCount,
            "responseTokenCount": responseTokenCount,
            "multiCommands": multiCommands,
            "answersList": answersList
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            `Conducted Authoring`,
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, authoringinfo);
    }
    indexDataOnAMA = (orignalCitation, AMACitation, sessionid, requestTokenCount, responseTokenCount) => {
        let authoringinfo = {
            "orignalCitation": orignalCitation,
            "AMACitation": AMACitation,
            "sessionid": sessionid,
            "requestTokenCount": requestTokenCount,
            "responseTokenCount": responseTokenCount
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            `Conducted AMACitation`,
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, authoringinfo);
    }
    numberOfWords = (str) => {
        if (str) {
            const words = str.match(/\S+/g);
            if (words && words.length !== 0) {
                return words.length;
            }
            else {
                return 0;
            }
        } else {
            return 0;
        }
    }
    handleFullContent = async (_file) => {
        let resp;
        let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/Content?fileType=Document`;
        //API_ENDPOINT = "https://localhost:44376/api/PreviewService/Content?fileType=Document";
        const formData = new FormData();
        formData.append('form_filed_name', _file)
        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        axios.post(API_ENDPOINT, formData, {
            headers: _headers
        }).then((response) => {
            resp = response.data;
            this.setState({ allFileContent: resp.PagesContent })
        }).catch((error) => {
            console.log(error);
            this.errorAlertMessage("Something went wrong. So we couldn't get full document content.");
        }).finally(() => {
            //this.setState({ isProcessingSelectAllText: false })
        })

    }

    onSummeryClick = async (e) => {
        let { orignalText, commandText, chatConversation, commandType, sessionID, allFileContent,
            summarizeText, isConfirm, isClearAllFields, previousOrignalText, uploadFile, firstCall
        } = this.state;
        this.setState({ savingCommandText: commandText })
        orignalText = (orignalText) ? orignalText : allFileContent
        if (orignalText || (uploadFile && ExcelFileTypes.includes(uploadFile.type))) {
            let _commandType = commandType;
            let _commandText = commandText;
            let tokenLength = this.numberOfWords(orignalText);
            if (_commandType === 'UserInstructions' && !commandText) {
                this.errorAlertMessage("User Command Required, Please enter a command.");
            }
            else if (_commandType === 'Translate' && !commandText) {
                this.errorAlertMessage("Please enter language to the command box.");
            } else if (!isConfirm && ShowWordCountForCommandType.includes(commandType) && tokenLength > WordsMaxLength) {
                this.showConfirmMessage(`The input text is more than ${WordsMaxLength} words. Please use a shorter text by hitting cancel button and updating the text or the text can be ${_commandType} upto max limit by clicking on OK button`);
            } else if (_commandType === 'UserInstructions' && commandText && commandText.trim() && commandText.trim().split(/\n\n/g).length > 5) {
                this.errorAlertMessage("Kindly select maximum five commands to proceed.");
            } else {

                if (_commandType === 'UserInstructions' && (!uploadFile || (uploadFile && !ExcelFileTypes.includes(uploadFile.type)))) {
                    let commandTexts = commandText.trim().split(/\n\n/g);
                    if (tokenLength > 7000 || commandTexts.length > 1) {
                        this.processUserInstructions();
                    } else {
                        this.setState({ chatConversation: chatConversation, isProcessing: true }, () => {
                            this.scrollToBottom();
                        });

                        let _orignalText = orignalText.replace(/[\r\n]/g, " ").trim();
                        if (ShowWordCountForCommandType.includes(commandType)) {
                            _orignalText = orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                        }
                        let config = {}
                        let url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        if (window.location.origin === 'https://predev-ims.jnj.com') {
                            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        }
                        const _headers = {
                            "Content-Type": "application/json"
                        }
                        if (await Authentication.isAccessTokenAvailable()) {
                            const token = await Authentication.getAccessToken();
                            _headers.Authorization = `Bearer ${token}`;
                        }
                        config = {
                            method: 'POST',
                            url: url,
                            headers: _headers,
                            data: {
                                "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                                "commandType": commandType,
                                "commandText": '',
                                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                                "sessionID": sessionID,
                                "wwid": JSON.parse(localStorage.getItem('wwid')),
                                "previousSummarizeText": '',
                                "searchID": "",
                                "isClearAllFields": isClearAllFields,
                                "isNewOrignalText": (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                                "multiCommands": commandTexts
                            }
                        }
                        // this.scrollToBottom();
                        await axios(config).then((response) => {
                            let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                            if (response.data.answersList && response.data.answersList.length > 0) {
                                if (response.data.requestTokenCount)
                                    requestTokenCount = response.data.requestTokenCount;
                                if (response.data.responseTokenCount)
                                    responseTokenCount = response.data.responseTokenCount;

                                this.setState({ lastCommandType: _commandType }, () => {

                                    commandTexts.forEach((citem, cindex) => {
                                        let _message = "";
                                        _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                        chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                                        _summarizeText = response.data.answersList[cindex] ? response.data.answersList[cindex].trim() : ""
                                        _summarizeText = _summarizeText.replace(/\n/g, '<br/>')//.replace(/>/g, '&gt;').replace(/</g, '&lt;')
                                        let finalSummery = JSON.parse(JSON.stringify(_summarizeText))
                                        chatConversation.push({ from: summarizeResult, message: finalSummery, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: true })
                                    })

                                })
                                this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, '', sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                            } else {
                                commandTexts.forEach((citem, cindex) => {
                                    let _message = "";
                                    _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                    chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                                    chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                                })

                            }
                            this.setState({
                                chatConversation: chatConversation,
                                summarizeText: _summarizeText
                            });
                        }).catch((error) => {
                            commandTexts.forEach((citem, cindex) => {
                                let _message = "";
                                _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                                chatConversation.push({ from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                            })
                            this.setState({ chatConversation: chatConversation });
                            console.log(error)
                        }).finally(() => {
                            this.setState({ isProcessing: false, isConfirm: false, isClearAllFields: false, previousOrignalText: orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false }, () => {
                                this.scrollToBottom();
                            });
                        });
                    }
                } else {
                    let _message = "";
                    if (uploadFile && ExcelFileTypes.includes(uploadFile.type)) {
                        _message = commandText ? `${commandText}\n File:${uploadFile.name}` : `File:${uploadFile.name}`;
                    } else {
                        _message = commandText ? `${commandText}\n${orignalText}` : `${orignalText}`;
                    }

                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                    chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                    this.setState({ chatConversation: chatConversation, isProcessing: true }, () => {
                        this.scrollToBottom();
                    });

                    let _orignalText = orignalText.replace(/[\r\n]/g, " ").trim();
                    if (ShowWordCountForCommandType.includes(commandType)) {
                        _orignalText = orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                    }
                    let config = {}
                    let requestUrl = ''
                    if (uploadFile && ExcelFileTypes.includes(uploadFile.type)) {
                        requestUrl = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_XL}qnachat/xl_upld`
                        if (window.location.origin === 'https://predev-ims.jnj.com') {
                            requestUrl = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_XL}qnachat/xl_upld`
                        }
                        //url = `https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_NLP_XL}qnachat/xl_upld`
                        const formData = new FormData();
                        if (firstCall) {
                            formData.append('key1', uploadFile);
                        }
                        formData.append("orignalText", _orignalText.replace(/[\r\n]/g, " ").trim());
                        formData.append("commandType", commandType);
                        formData.append("commandText", commandText);
                        formData.append("username", localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
                        formData.append("sessionID", sessionID);
                        formData.append("wwid", JSON.parse(localStorage.getItem('wwid')));
                        formData.append("previousSummarizeText", summarizeText.replace(/[\r\n]/g, " ").trim());
                        formData.append("searchID", "");
                        formData.append("isClearAllFields", isClearAllFields);
                        formData.append("isNewOrignalText", (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()));
                        formData.append("firstCall", firstCall);
                        const _headers = {
                            'content-type': 'multipart/form-data'
                        }
                        if (await Authentication.isAccessTokenAvailable()) {
                            const token = await Authentication.getAccessToken();
                            _headers.Authorization = `Bearer ${token}`;
                        }
                        config = {
                            method: 'POST',
                            url: requestUrl,
                            headers: _headers,
                            data: formData
                        }
                    }
                    else {
                        requestUrl = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        if (window.location.origin === 'https://predev-ims.jnj.com') {
                            requestUrl = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        }
                        const _headers = {
                            "Content-Type": "application/json"
                        }
                        if (await Authentication.isAccessTokenAvailable()) {
                            const token = await Authentication.getAccessToken();
                            _headers.Authorization = `Bearer ${token}`;
                        }
                        config = {
                            method: 'POST',
                            url: requestUrl,
                            headers: _headers,
                            data: {
                                "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                                "commandType": commandType,
                                "commandText": commandText,
                                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                                "sessionID": sessionID,
                                "wwid": JSON.parse(localStorage.getItem('wwid')),
                                "previousSummarizeText": summarizeText.replace(/[\r\n]/g, " ").trim(),
                                "searchID": "",
                                "isClearAllFields": isClearAllFields,
                                "isNewOrignalText": (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                                "multiCommands": [],
                            }
                        }
                    }
                    // this.scrollToBottom();
                    await axios(config).then((response) => {
                        let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                        if (uploadFile && ExcelFileTypes.includes(uploadFile.type)) {
                            if (response.data.answer) {
                                this.setState({ lastCommandType: _commandType }, () => {
                                    if (response.data.requestTokenCount)
                                        requestTokenCount = response.data.requestTokenCount;
                                    if (response.data.responseTokenCount)
                                        responseTokenCount = response.data.responseTokenCount;

                                    _summarizeText = response.data.answer.replace(/\n/g, '<br/>')//.replace(/>/g, '&gt;').replace(/</g, '&lt;')
                                    chatConversation.push({ from: summarizeResult, message: _summarizeText, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: true })
                                    this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                })
                                this.setState({
                                    chatConversation: chatConversation,
                                    summarizeText: _summarizeText
                                });
                            }
                            else {
                                chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: false })
                            }
                        }
                        else {
                            if (_commandType === "CreateTable") {
                                if (response.data.summarizeTable && response.data.summarizeTable.length > 0) {
                                    this.setState({ lastCommandType: _commandType }, () => {
                                        let summarizeTables = response.data.summarizeTable;
                                        if (response.data.requestTokenCount)
                                            requestTokenCount = response.data.requestTokenCount;
                                        if (response.data.responseTokenCount)
                                            responseTokenCount = response.data.responseTokenCount;

                                        if (summarizeTables.length === 1) {
                                            _summarizeText = summarizeTables[0];
                                            chatConversation.push({ from: summarizeResult, message: summarizeTables[0], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: true });
                                            this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                        }
                                    })
                                } else {
                                    chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: false })
                                }
                            } else {
                                if (response.data.summarizeText) {
                                    _summarizeText = response.data.summarizeText ? response.data.summarizeText.trim() : ""
                                    if (response.data.requestTokenCount)
                                        requestTokenCount = response.data.requestTokenCount;
                                    if (response.data.responseTokenCount)
                                        responseTokenCount = response.data.responseTokenCount;

                                    this.setState({ lastCommandType: _commandType }, () => {
                                        _summarizeText = _summarizeText.replace(/\n/g, '<br/>')//.replace(/>/g, '&gt;').replace(/</g, '&lt;')
                                        chatConversation.push({ from: summarizeResult, message: _summarizeText, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: true })
                                    })
                                    this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                } else {
                                    chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: false })
                                }
                            }
                            this.setState({
                                chatConversation: chatConversation,
                                summarizeText: (_commandType === "Summarize" || _commandType === "UserInstructions" || _commandType === "Translate" || _commandType === "QnA") ? (response.data.summarizeText ? response.data.summarizeText.trim() : "") : _summarizeText
                            });
                        }


                    }).catch((error) => {
                        chatConversation.push({ from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: orignalText, IsSucceed: false })
                        this.setState({ chatConversation: chatConversation });
                        console.log(error)
                    }).finally(() => {
                        this.setState({ isProcessing: false, isConfirm: false, isClearAllFields: false, previousOrignalText: orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false }, () => {
                            this.scrollToBottom();
                        });
                    });
                }
            }
        }
    }
    processUserInstructions = async () => {
        let { commandText, orignalText } = this.state;
        let _newQuestion = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
        let _splitQuery = _newQuestion.trim().split(/\n/g);;
        let tokenLength = this.numberOfWords(orignalText);
        let questionBatchSize = 3;
        if (tokenLength > 10000) {
            questionBatchSize = 2;
        }
        let totalquestionBatchs = Math.ceil(_splitQuery.length / questionBatchSize);
        this.setState({ isProcessing: true, spinnerMessage: "Please wait..." })
        for (let i = 0; i < totalquestionBatchs; i++) {
            let _batch = _splitQuery.slice(i * questionBatchSize, (i * questionBatchSize) + questionBatchSize);
            await this.onUserInstructionsCall(_batch);
            this.setState({ isMultiQuestionProcessing: true, isProcessing: false, spinnerMessage: "" }, () => {
                if (i === 0) {
                    this.scrollToBottom();
                }
            })
        }
        this.setState({ isMultiQuestionProcessing: false })
    }
    onUserInstructionsCall = async (commandTexts) => {
        let { orignalText, commandText, chatConversation, commandType, sessionID,
            isClearAllFields, previousOrignalText, uploadFile
        } = this.state;
        this.setState({ savingCommandText: commandText })
        if (orignalText || (uploadFile && ExcelFileTypes.includes(uploadFile.type))) {
            let _commandType = commandType;

            //let commandTexts = commandText.trim().split(/\n\n/g);
            this.setState({ chatConversation: chatConversation, isProcessing: true }, () => {
                this.scrollToBottom();
            });

            let _orignalText = orignalText.replace(/[\r\n]/g, " ").trim();
            if (ShowWordCountForCommandType.includes(commandType)) {
                _orignalText = orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
            }
            let config = {}
            var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
            if (window.location.origin === 'https://predev-ims.jnj.com') {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
            }
            const _headers = {
                "Content-Type": "application/json"
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                    "commandType": commandType,
                    "commandText": '',
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "sessionID": sessionID,
                    "wwid": JSON.parse(localStorage.getItem('wwid')),
                    "previousSummarizeText": '',
                    "searchID": "",
                    "isClearAllFields": isClearAllFields,
                    "isNewOrignalText": (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                    "multiCommands": commandTexts
                }
            }
            // this.scrollToBottom();
            await axios(config).then((response) => {
                let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                if (response.data.answersList && response.data.answersList.length > 0) {
                    if (response.data.requestTokenCount)
                        requestTokenCount = response.data.requestTokenCount;
                    if (response.data.responseTokenCount)
                        responseTokenCount = response.data.responseTokenCount;

                    this.setState({ lastCommandType: _commandType }, () => {

                        commandTexts.forEach((citem, cindex) => {
                            let _message = "";
                            _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                            _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                            chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                            _summarizeText = response.data.answersList[cindex] ? response.data.answersList[cindex].trim() : ""
                            _summarizeText = _summarizeText.replace(/\n/g, '<br/>')//.replace(/>/g, '&gt;').replace(/</g, '&lt;')
                            let finalSummery = JSON.parse(JSON.stringify(_summarizeText))
                            chatConversation.push({ from: summarizeResult, message: finalSummery, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: true })
                        })

                    })
                    this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, '', sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                } else {
                    commandTexts.forEach((citem, cindex) => {
                        let _message = "";
                        _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                        chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                        chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                    })

                }
                this.setState({
                    chatConversation: chatConversation,
                    summarizeText: _summarizeText
                });
            }).catch((error) => {
                commandTexts.forEach((citem, cindex) => {
                    let _message = "";
                    _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                    chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                    chatConversation.push({ from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                })
                this.setState({ chatConversation: chatConversation });
                console.log(error)
            }).finally(() => {
                this.setState({ //isProcessing: false,
                    isConfirm: false, isClearAllFields: false, previousOrignalText: orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false
                }, () => {
                    //this.scrollToBottom();
                });
            });

        }
    }
    onNotebookClick = () => {
        let { summarizeText, lastCommandType, orignalText } = this.state;
        this.setState({
            savingSummarizeText: summarizeText,
            savingCommandType: lastCommandType,
            savingOrignalText: orignalText,
            showNotebookList: true,
            isClickOnSelectNotebook: true,
        });
    }
    onNotebookWithPreviewClick = () => {
        let { summarizeText, lastCommandType, orignalText } = this.state;
        if (summarizeText) {
            this.setState({
                savingSummarizeText: summarizeText,
                savingCommandType: lastCommandType,
                savingOrignalText: orignalText,
                showNotebookPreviewList: true
            });
        }
    }
    handleCloseNotebookList = () => {

        this.setState({ showNotebookList: false, showNotebookPreviewList: false, isFromGlobalFeaturesMenuForNotebook: false });
    }
    updateSelectedNotebook = (selectedName, isNew, selectedNotebook) => {
        this.setState({
            selectedNotebook: selectedNotebook,
            isNewNotebook: isNew,
            selectedNotebookName: selectedName,
        });
    }
    handleSelectedNotebook = (selectedName, isNew, selectedNotebook, showNotebookList = false) => {
        let { isClickOnSelectNotebook } = this.state;
        this.setState({
            selectedNotebook: selectedNotebook,
            isNewNotebook: isNew,
            selectedNotebookName: selectedName,
            showNotebookList: showNotebookList,
            isFromGlobalFeaturesMenuForNotebook: false
        }, async () => {
            if (!isClickOnSelectNotebook) {
                await this.onclickProceed();
            } else {
                this.setState({
                    isClickOnSelectNotebook: false,
                })
            }
        });
    }
    handleCloseCommandList = () => {
        this.setState({
            showCommandList: false,
            isUserCommand: true,
            isTemplateCommand: false,
            isFromGlobalFeaturesMenu: false,
            isFromGlobalFeaturesMenuForNotebook: false
        });
    }
    handleZoomButtonOnClick = (status) => {
        let { sliderValue } = this.state;

        if (status === 'increment' && sliderValue !== 20) {
            sliderValue += 1;
        }
        else if (status === 'decrement' && sliderValue !== 10) {
            sliderValue -= 1;
        }

        this.setState({
            sliderValue: sliderValue,
        })

    };
    onRangeValueChange = (event) => {
        let sliderValue = parseInt(event.target.value);
        this.setState({
            sliderValue: sliderValue,
        });
    }
    onResetClick = () => {
        var guid = uuidv4();
        this.setState({
            orignalText: '',
            summarizeText: '',
            commandText: '',
            commandType: 'UserInstructions',
            chatConversation: [],
            notesText: '',
            citationText: '',
            sessionID: guid,
            selectedNotebook: null,
            isNewNotebook: false,
            selectedNotebookName: "",
            selectAllText: false,
            isClearAllFields: true,
            previousOrignalText: "",
            firstCall: true
        });
    }
    onExpandAllFieldsClick = () => {
        this.setState({ expandAllFields: true });
    }
    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    snippetLongFileNameString = (snippet) => {
        if (snippet.length > 16) {
            let text = snippet.substring(0, 16)//cuts to 70
            // let last = text.lastIndexOf(" ")//gets last space (to avoid cutting the middle of a word)
            // text = text.substring(0, 70)//cuts from last space (to avoid cutting the middle of a word)
            text = text + `...`//adds (...) at the end to show that it's cut
            return text
        }
        return snippet;
    }
    async fileInputChange(filestoUpload) {
        this.setState({ isFileProcessing: false }, async () => {
            const singleFile = filestoUpload[0];
            if (ExcelFileTypes.includes(singleFile.type)) {
                await this.processExcel(singleFile);
            } else if (fileTypes.includes(singleFile.type)) {
                var url = URL.createObjectURL(singleFile);
                this.setState({
                    uploadFile: singleFile, uploadFilePlaceHolder: singleFile.name, uploadFileType: singleFile.type,
                    previewURL: url, showPreviewModel: true, showPreview: true, isFileProcessing: false, selectAllText: false
                });
            }
            else {
                this.errorAlertMessage("Upload Failed. Please upload the document in a valid format.");
            }
        });
    }
    async processExcel(file) {
        let reader = new FileReader();
        const singleFile = file;
        reader.readAsArrayBuffer(singleFile);
        reader.onload = (e) => {
            let excelFile = e.target.result;
            const workbook = XLSX.read(excelFile, { type: 'buffer', cellStyles: true });
            let excelFileData = {};
            let _sheetNames = [];
            for (let i = 0; i < workbook.SheetNames.length; i++) {
                const worksheetName = workbook.SheetNames[i];
                const worksheet = workbook.Sheets[worksheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
                let _worksheetData = [];
                let colsDetails = worksheet["!cols"]
                if (data.length > 0) {
                    let keys = Object.keys(data[0]);
                    let _singleData = [];
                    keys.forEach((key, i) => {
                        let _width = 150;
                        if (colsDetails && colsDetails[i]) {
                            _width = colsDetails[i].wpx
                        }
                        _singleData.push({
                            value: key,
                            width: _width,
                            className: "previewExcelTHeaderTh",
                            readOnly: true

                        })
                    })
                    _worksheetData.push(_singleData);
                    data.forEach((eData) => {
                        let _singleData = [];
                        keys.forEach(key => {
                            _singleData.push({
                                value: eData[key],
                                className: "previewExcelTBodyTD",
                                readOnly: true
                            })
                        })
                        _worksheetData.push(_singleData);
                    })
                    excelFileData[worksheetName] = _worksheetData;
                    _sheetNames.push(worksheetName)
                }

            }
            if (_sheetNames.length > 0) {
                var guid = uuidv4();
                this.setState({
                    uploadFile: singleFile, uploadFilePlaceHolder: singleFile.name, uploadFileType: singleFile.type,
                    previewURL: '', showPreviewModel: true, showPreview: true, isFileProcessing: false,
                    excelSheetNames: _sheetNames,
                    selectedExcelSheetName: _sheetNames[0],
                    excelFileData: excelFileData,
                    sessionID: guid,
                    firstCall: true,
                    selectAllText: false,
                });
            } else {
                this.setState({
                    isFileProcessing: false,
                    showPreview: true,
                    selectAllText: false
                }, () => {
                    this.errorAlertMessage("Upload Failed. Your file wasn't uploaded because worksheet not found in upload file.");
                });
            }


        }
    }

    // async fileInputChange(event) {
    //     this.setState({ isFileProcessing: true }, async () => {
    //         const files = event.target.files;
    //         const singleFile = files[0];
    //         if (ExcelFileTypes.includes(singleFile.type)) {
    //             await this.processExcel(event);
    //         } else {
    //             var url = URL.createObjectURL(singleFile);
    //             this.setState({
    //                 uploadFile: singleFile, uploadFilePlaceHolder: singleFile.name, uploadFileType: singleFile.type,
    //                 previewURL: url, showPreviewModel: true, showPreview: true, isFileProcessing: false, selectAllText: false
    //             });
    //         }
    //         await this.handleFullContent(singleFile)
    //     });
    // }
    // async processExcel(event) {
    //     let reader = new FileReader();
    //     const files = event.target.files;
    //     const singleFile = files[0];
    //     reader.readAsArrayBuffer(singleFile);
    //     reader.onload = (e) => {
    //         let excelFile = e.target.result;
    //         const workbook = XLSX.read(excelFile, { type: 'buffer', cellStyles: true });
    //         let excelFileData = {};
    //         let _sheetNames = [];
    //         for (let i = 0; i < workbook.SheetNames.length; i++) {
    //             const worksheetName = workbook.SheetNames[i];
    //             const worksheet = workbook.Sheets[worksheetName];
    //             const data = XLSX.utils.sheet_to_json(worksheet);
    //             let _worksheetData = [];
    //             let colsDetails = worksheet["!cols"]
    //             if (data.length > 0) {
    //                 let keys = Object.keys(data[0]);
    //                 let _singleData = [];
    //                 keys.map((key, i) => {
    //                     let _width = 150;
    //                     if (colsDetails && colsDetails[i]) {
    //                         _width = colsDetails[i].wpx
    //                     }
    //                     _singleData.push({
    //                         value: key,
    //                         width: _width,
    //                         className: "previewExcelTHeaderTh",
    //                         readOnly: true

    //                     })
    //                 })
    //                 _worksheetData.push(_singleData);
    //                 data.map((eData) => {
    //                     let _singleData = [];
    //                     keys.map(key => {
    //                         _singleData.push({
    //                             value: eData[key],
    //                             className: "previewExcelTBodyTD",
    //                             readOnly: true
    //                         })
    //                     })
    //                     _worksheetData.push(_singleData);
    //                 })
    //                 excelFileData[worksheetName] = _worksheetData;
    //                 _sheetNames.push(worksheetName)
    //             }

    //         }
    //         if (_sheetNames.length > 0) {
    //             var guid = uuidv4();
    //             this.setState({
    //                 uploadFile: singleFile, uploadFilePlaceHolder: singleFile.name, uploadFileType: singleFile.type,
    //                 previewURL: '', showPreviewModel: true, showPreview: true, isFileProcessing: false,
    //                 excelSheetNames: _sheetNames,
    //                 selectedExcelSheetName: _sheetNames[0],
    //                 excelFileData: excelFileData,
    //                 sessionID: guid,
    //                 firstCall: true,
    //                 selectAllText: false,
    //             });
    //         } else {
    //             this.setState({
    //                 isFileProcessing: false,
    //                 showPreview: true,
    //                 selectAllText: false
    //             }, () => {
    //                 this.errorAlertMessage("Upload Failed. Your file wasn't uploaded because worksheet not found in upload file.");
    //             });
    //         }


    //     }
    // }

    snippetLongString = (snippet) => {
        if (snippet.length > 150) {
            let text = "";
            let spanIndex = snippet.indexOf('<span class=');
            if (spanIndex !== -1) {
                text = snippet.substring(spanIndex, (spanIndex + 150))//cuts to spanIndex+150
                let last = text.lastIndexOf(" ")//gets last space (to avoid cutting the middle of a word)
                text = text.substring(0, last)//cuts from last space (to avoid cutting the middle of a word)
            } else {
                text = snippet.substring(0, 150)//cuts to 70
                let last = text.lastIndexOf(" ")//gets last space (to avoid cutting the middle of a word)
                text = text.substring(0, last)//cuts from last space (to avoid cutting the middle of a word)
            }
            //text = text + ` ...`//adds (...) at the end to show that it's cut
            return text
        }
        return snippet;
    }
    renderChatConversation = () => {
        let { chatConversation, isProcessing, previewURL, isMultiQuestionProcessing } = this.state;
        return (
            <>
                <div className="chat-body">
                    {chatConversation.map((conversation, conversationIndex) => {
                        if (conversation.from === userQuestion) {
                            return (
                                <AuthoringUserSummery key={`my-message-${conversationIndex}`} conversation={conversation} />
                            )

                        } else {
                            return (
                                <div className="message info" key={`summery-message-${conversationIndex}`}>
                                    {/* <img alt='avatar' className="img-circle medium-image" src="https://bootdey.com/img/Content/avatar/avatar1.png" /> */}
                                    <img alt='avatar' className="img-circle medium-image" src={robotHeadChatgpt} />
                                    <div className="message-body">
                                        <div className="message-text" dangerouslySetInnerHTML={{ __html: sanitize(conversation.message) }} />
                                        <div className="message-info message-info-add-to-notes message-info-gpt-add-to-notes">
                                            <h5>{conversation.messageTimeInText} </h5>
                                            {/* {(conversation.IsSucceed && conversation.commandType !== 'CreateTable') && <span title="Add to Notes" className="add-to-notes-action-text" onClick={() => this.handleAddToNotes(conversation.message)}>Add to Notes</span>} */}
                                            {(conversation.IsSucceed) && <span title="Add to Notebook" className="add-to-notebook-action-text add-to-notebook-action-text-gpt" onClick={() => { previewURL ? this.handleAddToNotebookPreview(conversation.message, conversation.commandType, conversation.orignalText, conversation.commandText) : this.handleAddToNotebook(conversation.message, conversation.commandType, conversation.orignalText, conversation.commandText) }}>Add to Notebook</span>}
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            )
                        }

                    })
                    }

                    <div style={{ width: "100%" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                        {(isProcessing || isMultiQuestionProcessing) && <div style={{ textAlign: "center", marginBottom: "10px" }}>
                            <img src={imsLoader} alt="Loading Filters" style={{ width: "10%" }} />
                        </div>}
                    </div>
                </div>

            </>
        )
    }
    handlePreviewClose = async () => {
        this.setState({ showPreviewModel: false },
            async () => {
                setTimeout(() => {
                    document.body.classList.remove('custome-modal-open');
                }, 1000);
            })
    }
    handleOpenPDF = () => {
        this.setState({ showPreviewModel: true })
    }
    handleClosePDF = () => {
        this.setState({
            uploadFilePlaceHolder: "Upload Document",
            uploadFile: null,
            previewURL: '',
            showPreview: false,
            showPreviewModel: false,
            excelSheetNames: [],
            selectedExcelSheetName: "",
            excelFileData: {},
            uploadFileType: '',
            tabIndex: 0,
        })
    }
    renderAllText = () => {
        let { isProcessingSelectAllText, selectAllText, orignalText } = this.state;
        if (selectAllText && isProcessingSelectAllText) {
            return (
                <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <img src={imsLoader} alt="Loading Filters" style={{ width: "10%" }} />
                </div>
            )
        }
        else {
            return (
                <textarea className="txt-authoring-summarize" ref={(input) => { this.sourceTextInput = input; }} placeholder="Enter the source text here." name="exportText" value={orignalText} onChange={(e) => this.handleSummery(e)} />
            )
        }
    }
    onAllTextClick = async () => {
        let { selectAllText, uploadFile } = this.state;
        let resp = [];
        if (!selectAllText) {
            this.setState({
                selectAllText: true,
                isProcessingSelectAllText: true
            })

            let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/Content?fileType=Document`;
            //API_ENDPOINT = "https://localhost:44376/api/PreviewService/Content?fileType=Document";
            const formData = new FormData();
            formData.append('form_filed_name', uploadFile)
            const _headers = {
                'content-type': 'multipart/form-data'
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            axios.post(API_ENDPOINT, formData, {
                headers: _headers
            }).then((response) => {
                resp = response.data;
                this.setState({ orignalText: resp.PagesContent })
            }).catch((error) => {
                console.log(error);
                this.errorAlertMessage("Something went wrong. So we couldn't get full document content.");
                this.setState({
                    selectAllText: false
                })
            }).finally(() => {
                this.setState({ isProcessingSelectAllText: false })
            })


            // let service = new Services();
            // await axios.get(url).then((response) => {
            //     resp = response.data;
            //     this.setState({ orignalText: resp.PagesContent })
            //     this.props.handleSummery(resp.PagesContent);
            // }).catch((error) => {
            //     service.logService(`API call error for ${url}: ${error}`, 'error')
            // }).finally(() => {
            //     this.setState({ isProcessingSelectAllText: false })
            // })
        }
        else {
            this.setState({
                selectAllText: false,
                orignalText: ""
            })
        }
    }
    renderModelLoader() {
        let { isFileProcessing } = this.state;
        return (<Modal
            show={isFileProcessing}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="savePopUp"
            className="document-processing-contentPopUp"
            scrollable={true}
            backdropClassName="document-processing-contentPopUp-backdrop"
        >
            <div style={{ padding: "0 5%" }}>
                <div style={{ fontSize: "14px", textAlign: "center" }}>
                    <Modal.Body>
                        <img src={imsLoader} alt="" width={100} height={100} />
                        <div className="saveModal-heading" style={{ color: "#0074B0" }}>Please wait while your document is getting uploaded</div>
                    </Modal.Body>
                </div>
            </div>
        </Modal>)
    }
    onDoubleClick = (e) => {
        this.errorAlertMessage("Added document is read only. Kindly modify offline and re-upload.");
    }
    cellRenderer = (props) => {
        const { ...rest } = props;
        return (
            <td {...rest} onDoubleClick={e => this.onDoubleClick(e)}>
                {props.children}
            </td>
        )
    }

    renderReactDataSheet() {
        const { selectedExcelSheetName, excelFileData } = this.state;
        let excelData = excelFileData[selectedExcelSheetName];

        return (<ReactDataSheet
            data={excelData}
            valueRenderer={cell => cell.value}
            cellRenderer={this.cellRenderer}
        />)
    }
    clickTabList = () => {
        setTimeout(() => {
            let _tabList = document.getElementById('TabList');
            _tabList.click();
            _tabList.focus();
        }, 1000);
    }
    excelSheetNamesList = () => {
        let { excelSheetNames, tabIndex } = this.state;
        return (
            <Tabs selectedIndex={tabIndex} onSelect={(index) => {
                this.setState({ tabIndex: index, selectedExcelSheetName: excelSheetNames[index] },
                    () => {
                        this.clickTabList();
                    })
            }}>
                <TabList id="TabList">
                    {
                        excelSheetNames.map(x => {
                            return (<Tab>{x}</Tab>)
                        })
                    }
                </TabList>
                <TabPanel></TabPanel>
            </Tabs>);
    }
    render() {
        const { orignalText, summarizeText, showNotebookList, commandText,
            commandType, lastCommandType, notesText, citationText, sliderValue, showCommandList, isFromGlobalFeaturesMenu, isTemplateCommand, isUserCommand, sessionID } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        const { expandNotes, expandSourceText, expandAllFields, expandCitation, expandCommand } = this.state;
        const { savingSummarizeText, savingCommandType, savingOrignalText, isFromGlobalFeaturesMenuForNotebook } = this.state;
        const { savingCommandText, selectedNotebookName, isCitationProcessing, isProcessing, isMultiQuestionProcessing, selectAllText, showNotebookPreviewList } = this.state;
        const { uploadFilePlaceHolder, previewURL, showPreview } = this.state;
        const { confirmMessageContent, confirmMessageShowModal } = this.state;
        const { uploadFileType, showDisclaimerPopup } = this.state;
        let totalWords = this.numberOfWords(orignalText);
        return (<div className="authoring-gpt-container">
            <div className="authoring-gpt-header">
                <div className="popup-authoring-img-wrapper">
                    <img
                        src={iconiMSAuthoring}
                        alt=""
                        className="popup-authoring-img"
                    />
                </div>
                <button type="button" className="authoring-model-body-content-link" onClick={() => { this.setState({ showDisclaimerPopup: true }) }} >Gen Ai Adherence Policy</button>
            </div>
            <Dropzone
                autoFocus={true}
                onDrop={this.onDrop}
                onDropRejected={this.onDropRejected}
                onDropAccepted={this.onDropAccepted}
                onError={this.onError}
                maxFiles={1}
            >
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <div className="authoring-gpt-body" >
                         {(isDragActive) && (
                                <div className="gen-ai-authoring-main-section-drop-zone">
                                    <div className="gen-ai-authoring-main-section-message">Drag and drop file here</div>
                                </div>)}
                        {(previewURL || ExcelFileTypes.includes(uploadFileType)) ?
                            <>
                                <div className="authoring-gpt-left">
                                    <div className="authoring-gpt-preview-wrapper">
                                        <div className="authoring-gpt-preview-label">
                                            <span style={{ display: "flex" }}>
                                                {/* accept="application/pdf" */}
                                                <input type="file" key={showPreview} name="pdfUploadFile" id="pdfUploadFile" accept=".pdf, .xls, .xlsx" onChange={e => { this.fileInputChange(e) }} style={{ display: "none" }} />
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30px" height="24px">
                                                    <path fill="#fefdef" d="M29.614,12.307h-1.268c-4.803,0-8.732,3.93-8.732,8.732v61.535c0,4.803,3.93,8.732,8.732,8.732h43.535c4.803,0,8.732-3.93,8.732-8.732v-50.02C72.74,24.68,68.241,20.182,60.367,12.307H41.614" /><path fill="#1f212b" d="M71.882,92.307H28.347c-5.367,0-9.732-4.366-9.732-9.732V21.04c0-5.367,4.366-9.732,9.732-9.732h1.268c0.552,0,1,0.448,1,1s-0.448,1-1,1h-1.268c-4.264,0-7.732,3.469-7.732,7.732v61.535c0,4.264,3.469,7.732,7.732,7.732h43.535c4.264,0,7.732-3.469,7.732-7.732V32.969L59.953,13.307H41.614c-0.552,0-1-0.448-1-1s0.448-1,1-1h18.752c0.265,0,0.52,0.105,0.707,0.293l20.248,20.248c0.188,0.188,0.293,0.442,0.293,0.707v50.02C81.614,87.941,77.248,92.307,71.882,92.307z" /><path fill="#fef6aa" d="M60.114,12.807v10.986c0,4.958,4.057,9.014,9.014,9.014h11.986" /><path fill="#1f212b" d="M81.114 33.307H69.129c-5.247 0-9.515-4.268-9.515-9.515V12.807c0-.276.224-.5.5-.5s.5.224.5.5v10.985c0 4.695 3.82 8.515 8.515 8.515h11.985c.276 0 .5.224.5.5S81.391 33.307 81.114 33.307zM75.114 51.307c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5s.5.224.5.5v3C75.614 51.083 75.391 51.307 75.114 51.307zM75.114 59.307c-.276 0-.5-.224-.5-.5v-6c0-.276.224-.5.5-.5s.5.224.5.5v6C75.614 59.083 75.391 59.307 75.114 59.307zM67.956 86.307H32.272c-4.223 0-7.658-3.45-7.658-7.689V25.955c0-2.549 1.264-4.931 3.382-6.371.228-.156.54-.095.695.132.155.229.096.54-.132.695-1.844 1.254-2.944 3.326-2.944 5.544v52.663c0 3.688 2.987 6.689 6.658 6.689h35.685c3.671 0 6.658-3.001 6.658-6.689V60.807c0-.276.224-.5.5-.5s.5.224.5.5v17.811C75.614 82.857 72.179 86.307 67.956 86.307z" /><path fill="#1f212b" d="M39.802 14.307l-.117 11.834c0 2.21-2.085 3.666-4.036 3.666-1.951 0-4.217-1.439-4.217-3.649l.037-12.58c0-1.307 1.607-2.451 2.801-2.451 1.194 0 2.345 1.149 2.345 2.456l.021 10.829c0 0-.083.667-1.005.645-.507-.012-1.145-.356-1.016-.906v-9.843h-.813l-.021 9.708c0 1.38.54 1.948 1.875 1.948s1.959-.714 1.959-2.094V13.665c0-2.271-1.36-3.5-3.436-3.5s-3.564 1.261-3.564 3.532l.032 12.11c0 3.04 2.123 4.906 4.968 4.906 2.845 0 5-1.71 5-4.75V14.307H39.802zM53.114 52.307h-23c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h23c.276 0 .5.224.5.5S53.391 52.307 53.114 52.307zM44.114 59.307h-14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h14c.276 0 .5.224.5.5S44.391 59.307 44.114 59.307zM70.114 59.307h-24c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h24c.276 0 .5.224.5.5S70.391 59.307 70.114 59.307zM61.114 66.307h-11c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h11c.276 0 .5.224.5.5S61.391 66.307 61.114 66.307zM71.114 66.307h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5S71.391 66.307 71.114 66.307zM48.114 66.307h-18c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h18c.276 0 .5.224.5.5S48.391 66.307 48.114 66.307zM70.114 73.307h-13c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h13c.276 0 .5.224.5.5S70.391 73.307 70.114 73.307zM54.114 73.307h-24c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h24c.276 0 .5.224.5.5S54.391 73.307 54.114 73.307z" />
                                                </svg>
                                                {/* <img src={pdfIcon} width={20} /> */}
                                                <label for="pdfUploadFile" className="authoring-gpt-file-upload" title={uploadFilePlaceHolder} style={{ cursor: "pointer" }}>
                                                    {uploadFilePlaceHolder}</label>
                                                {(previewURL || ExcelFileTypes.includes(uploadFileType)) ? <>
                                                    &nbsp;
                                                    <button style={{ padding: "0 5px 5px 5px" }} title="Clear File" onClick={e => this.handleClosePDF()}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 50 50">
                                                            <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>
                                                        </svg>
                                                    </button>
                                                </> : <>&nbsp;</>}
                                            </span>
                                        </div>
                                        {previewURL && <div className="authoring-gpt-preview-panel">
                                            <object data={previewURL} width="100%" height="100%">
                                                <p>Unable to display PDF file. </p>
                                            </object>
                                        </div>}
                                        {ExcelFileTypes.includes(uploadFileType) &&
                                            <>
                                                <div className="authoring-gpt-excel-preview-panel">
                                                    {this.renderReactDataSheet()}
                                                </div>
                                                <div style={{ textAlign: "center", overflow: "auto", height: "45px" }}>
                                                    {this.state.excelSheetNames.length > 0 && this.excelSheetNamesList()}
                                                </div>
                                            </>
                                        }


                                    </div>

                                </div>
                                <div className="authoring-gpt-right">
                                    <div className="authoring-summery-text-to-edit-wrapper-gpt">
                                        <div className="authoring-text-to-edit-label-gpt">
                                            <span>Source Text</span>
                                            {(!ExcelFileTypes.includes(uploadFileType)) && <div className="authoring-all-text-select-gpt">
                                                <input type="checkbox" title="All Text File" className="all-text-checkbox" onChange={e => {
                                                    this.onAllTextClick()
                                                }} checked={selectAllText} /><span>Use Full Document</span>
                                            </div>}

                                            {ShowWordCountForCommandType.includes(commandType) && <div className={totalWords < WordsMaxLength ? "summarize-count summarize-count-font" : "summarize-count summarize-count-color summarize-count-font"}>
                                                <span className="current">{totalWords}</span>
                                                <span className="maximum">/{WordsMaxLength} Words &nbsp;</span>
                                            </div>
                                            }
                                            <button title="Source Text Expand" class="btn-like-expandAll" onClick={e => {
                                                this.handleOnClickSourceTextExpand()
                                            }}><img src={expandAllBlueIcon} alt="Expand" />
                                            </button>
                                        </div>
                                        <div className="authoring-text-to-edit-panel-gpt">
                                            {this.renderAllText()}
                                        </div>

                                    </div>
                                    <div className="authoring-summery-comment-send-save-notebook-wrapper-gpt">
                                        <div className="authoring-command-label-gpt">
                                            <span>Command</span>
                                            <button title="Command Expand" class="btn-like-expandAll" onClick={e => {
                                                this.handleOnClickcommandTextExpand()
                                            }}><img src={expandAllBlueIcon} alt="Expand" />
                                            </button>
                                        </div>
                                        <div className="authoring-command-wrapper-panel-gpt">
                                            <div className="authoring-command-dropdown-panel-gpt">
                                                <select
                                                    className="authoring-command-dropdown-gpt"
                                                    onChange={this.handleChangeCommandType}
                                                    value={commandType}>
                                                    <option value="UserInstructions">User Instructions​</option>
                                                    <option value="CreateTable">Create Table​</option>
                                                    <option value="Summarize">Summarize</option>
                                                    <option value="Translate">Translate</option>
                                                    {/* <option value="QnA">QnA</option> */}
                                                </select>
                                            </div>
                                            <div className="authoring-summery-comment-send-gpt">
                                                <div className="authoring-comment-panel-gpt">
                                                    <textarea name="commandText" value={commandText} placeholder="Type Additional Commands here." onChange={(e) => this.handleComment(e)} />
                                                    <span title="Save Command" className="add-to-command-action-text add-to-command-action-save" onClick={() => this.handleAddToCommand()}>Save Command</span>
                                                </div>
                                                <div className="authoring-send-panel-gpt">
                                                    <button className="btnNotebook" type="button" onClick={(e) => this.onSummeryClick()}  >Submit</button>
                                                    <span title="My Commands" className="add-to-command-user-template" onClick={() => this.handleClickOnMyCommand()}>My Commands</span>
                                                    <span title="Template Commands" className="add-to-command-user-template" onClick={() => this.handleClickOnTemplateCommand()}>Template Commands</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="authoring-summery-result-wrapper-gpt">
                                        <div className="authoring-result-label-gpt">
                                            <span>Results</span>
                                        </div>
                                        <div className="authoring-result-panel-gpt">
                                            {this.renderChatConversation()}
                                        </div>
                                    </div>
                                    <div className="authoring-summery-citation-wrapper-gpt">
                                        <div className="authoring-gpt-citation-label">
                                            <span>Citation</span>
                                        </div>
                                        <div className="authoring-gpt-summery-citation-send">
                                            {isCitationProcessing ? <>
                                                <div style={{ textAlign: "center", marginBottom: "10px" }}>
                                                    <img src={imsLoader} alt="Loading Filters" style={{ width: "10%" }} />
                                                </div>
                                            </> : <>
                                                <textarea name="citationText" value={citationText} placeholder="Enter your citation here." onChange={(e) => this.handleCitation(e)} />
                                                <div className="add-to-citation-action-text add-to-command-gpt-action-save add-to-command-action-gpt">
                                                    <span className="authoring-summery-gpt-citation-link" title="Convert Citation" onClick={() => this.handleAddToConvertCitation()}>Convert Citation</span>
                                                    <span className="authoring-summery-citation-seprater"></span>
                                                    <span className="authoring-summery-gpt-citation-link" title="Clear Citation" onClick={this.handleOnClickClearCitationExpand}>Clear Citation</span>
                                                </div>
                                            </>}

                                        </div>
                                    </div>
                                    <div className="authoring-summery-comment-save-notebook-gpt">
                                        <div className="authoring-summery-btn-restart">
                                            <button disabled={isProcessing || isMultiQuestionProcessing} type="button" className="btnReset" onClick={(e) => this.onResetClick()} title="Clear All Fields">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 11.724 13.727">
                                                    <g id="ic_forward_30_24px" transform="translate(0.25 0.57)">
                                                        <path id="ic_forward_30_24px-2" data-name="ic_forward_30_24px" d="M4,8.744a5.417,5.417,0,0,0,5.612,5.163,5.417,5.417,0,0,0,5.612-5.163h-1.4a4.063,4.063,0,0,1-4.209,3.872A4.063,4.063,0,0,1,5.4,8.744,4.063,4.063,0,0,1,9.612,4.872V7.454l3.507-3.227L9.612,1V3.581A5.417,5.417,0,0,0,4,8.744Z" transform="translate(-4 -1)" fill="#ffffff" stroke="#0074B0" stroke-width="0.5" />
                                                    </g>
                                                </svg>
                                                <span>Clear All Fields</span>
                                            </button>
                                        </div>
                                        <div className="ai-authoring-summery-btn-expand-notebook-gpt">
                                            <button className="btnExpandAllFields" type="button" onClick={(e) => this.onExpandAllFieldsClick()}>Expand All Fields</button>
                                            <button className="btnNotebook" type="button" onClick={(e) => this.onNotebookWithPreviewClick()}>Save to Notebook</button>
                                        </div>
                                    </div>
                                </div></> :
                            <>
                                <div className="authoring-gpt-left">
                                    <div className="authoring-gpt-summery-text-to-edit-wrapper">
                                        <div className="authoring-gpt-text-to-edit-label">
                                            <span>Source Text  <button title="Source Text Expand" class="btn-like-expandAll" onClick={e => {
                                                this.handleOnClickSourceTextExpand()
                                            }}><img src={expandAllBlueIcon} alt="Expand" />
                                            </button></span>
                                            <span className="authoring-drag-n-drop-span">
                                                {/* accept="application/pdf" */}
                                                {/* <input type="file" key={showPreview} name="pdfUploadFile" id="pdfUploadFile" accept=".pdf, .xls, .xlsx" onChange={e => { this.fileInputChange(e) }} style={{ display: "none" }} /> */}
                                                {/* <label for="pdfUploadFile" style={{ cursor: "pointer" }}> */}
                                                {/* <img src={pdfIcon} width={20} /> */}
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30px" height="24px">
                                                <path fill="#fefdef" d="M29.614,12.307h-1.268c-4.803,0-8.732,3.93-8.732,8.732v61.535c0,4.803,3.93,8.732,8.732,8.732h43.535c4.803,0,8.732-3.93,8.732-8.732v-50.02C72.74,24.68,68.241,20.182,60.367,12.307H41.614" /><path fill="#1f212b" d="M71.882,92.307H28.347c-5.367,0-9.732-4.366-9.732-9.732V21.04c0-5.367,4.366-9.732,9.732-9.732h1.268c0.552,0,1,0.448,1,1s-0.448,1-1,1h-1.268c-4.264,0-7.732,3.469-7.732,7.732v61.535c0,4.264,3.469,7.732,7.732,7.732h43.535c4.264,0,7.732-3.469,7.732-7.732V32.969L59.953,13.307H41.614c-0.552,0-1-0.448-1-1s0.448-1,1-1h18.752c0.265,0,0.52,0.105,0.707,0.293l20.248,20.248c0.188,0.188,0.293,0.442,0.293,0.707v50.02C81.614,87.941,77.248,92.307,71.882,92.307z" /><path fill="#fef6aa" d="M60.114,12.807v10.986c0,4.958,4.057,9.014,9.014,9.014h11.986" /><path fill="#1f212b" d="M81.114 33.307H69.129c-5.247 0-9.515-4.268-9.515-9.515V12.807c0-.276.224-.5.5-.5s.5.224.5.5v10.985c0 4.695 3.82 8.515 8.515 8.515h11.985c.276 0 .5.224.5.5S81.391 33.307 81.114 33.307zM75.114 51.307c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5s.5.224.5.5v3C75.614 51.083 75.391 51.307 75.114 51.307zM75.114 59.307c-.276 0-.5-.224-.5-.5v-6c0-.276.224-.5.5-.5s.5.224.5.5v6C75.614 59.083 75.391 59.307 75.114 59.307zM67.956 86.307H32.272c-4.223 0-7.658-3.45-7.658-7.689V25.955c0-2.549 1.264-4.931 3.382-6.371.228-.156.54-.095.695.132.155.229.096.54-.132.695-1.844 1.254-2.944 3.326-2.944 5.544v52.663c0 3.688 2.987 6.689 6.658 6.689h35.685c3.671 0 6.658-3.001 6.658-6.689V60.807c0-.276.224-.5.5-.5s.5.224.5.5v17.811C75.614 82.857 72.179 86.307 67.956 86.307z" /><path fill="#1f212b" d="M39.802 14.307l-.117 11.834c0 2.21-2.085 3.666-4.036 3.666-1.951 0-4.217-1.439-4.217-3.649l.037-12.58c0-1.307 1.607-2.451 2.801-2.451 1.194 0 2.345 1.149 2.345 2.456l.021 10.829c0 0-.083.667-1.005.645-.507-.012-1.145-.356-1.016-.906v-9.843h-.813l-.021 9.708c0 1.38.54 1.948 1.875 1.948s1.959-.714 1.959-2.094V13.665c0-2.271-1.36-3.5-3.436-3.5s-3.564 1.261-3.564 3.532l.032 12.11c0 3.04 2.123 4.906 4.968 4.906 2.845 0 5-1.71 5-4.75V14.307H39.802zM53.114 52.307h-23c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h23c.276 0 .5.224.5.5S53.391 52.307 53.114 52.307zM44.114 59.307h-14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h14c.276 0 .5.224.5.5S44.391 59.307 44.114 59.307zM70.114 59.307h-24c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h24c.276 0 .5.224.5.5S70.391 59.307 70.114 59.307zM61.114 66.307h-11c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h11c.276 0 .5.224.5.5S61.391 66.307 61.114 66.307zM71.114 66.307h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5S71.391 66.307 71.114 66.307zM48.114 66.307h-18c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h18c.276 0 .5.224.5.5S48.391 66.307 48.114 66.307zM70.114 73.307h-13c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h13c.276 0 .5.224.5.5S70.391 73.307 70.114 73.307zM54.114 73.307h-24c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h24c.276 0 .5.224.5.5S54.391 73.307 54.114 73.307z" />
                                            </svg>
                                            {uploadFilePlaceHolder}</label> */}

                                                <section {...getRootProps({ className: 'container' })} style={{ padding: '0' }} className="">
                                                    <div style={{ cursor: 'pointer', border: '1px solid #bacef3', borderWidth: '3px', height: '47px', width: '100%', display: 'flex', alignItems: 'center' }}
                                                        
                                                        className={`dropzone ${isDragActive ? 'active-dropzone' : ''}`}
                                                    >
                                                        <label style={{ cursor: "pointer", position: 'relative', right: '10px' }}>
                                                            <svg width="30px" height="30px" viewBox="0 0 64.00 64.00" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--emojione-monotone" preserveAspectRatio="xMidYMid meet" fill="#ffffff" stroke="#ffffff" stroke-width="0.00064">
                                                                <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(0,0), scale(1)">
                                                                    <rect x="0" y="0" width="64.00" height="64.00" rx="32" fill="#2a498a" strokewidth="0"></rect>
                                                                </g>
                                                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.384"></g>
                                                                <g id="SVGRepo_iconCarrier">
                                                                    <path d="M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2zm5.143 28.305V49H26.857V30.305H16L32 15l16 15.305H37.143z" fill="#ffffff"></path>
                                                                </g>
                                                            </svg>
                                                        </label>
                                                        <input {...getInputProps()} />
                                                        {isDragActive ? (
                                                            <p style={{
                                                                textAlign: 'center',
                                                                width: '100%',
                                                                margin: 0
                                                            }}>Click to select a file or drag & drop document here</p>) : (
                                                            <p style={{
                                                                textAlign: 'center',
                                                                width: '100%',
                                                                margin: 0
                                                            }}>Click to select a file or drag & drop document here</p>)}
                                                    </div>
                                                </section>
                                                {previewURL ? <>
                                                    &nbsp;
                                                    <button style={{ padding: "0 5px 5px 5px" }} title="Clear PDF" onClick={e => this.handleClosePDF()}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 50 50">
                                                            <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>
                                                        </svg>
                                                    </button>
                                                </> : <>&nbsp;</>}
                                                <label style={{ fontSize: '12px', position: 'relative', top: '-2px', color: '#4c566a' }}>Supproted formats: PDF,MS-EXCEL,SHEET,CSV</label>
                                            </span>
                                        </div>
                                        <div className="authoring-gpt-text-to-edit-panel">
                                            <textarea className="txt-authoring-gpt-summarize" name="exportText" style={{ fontSize: `${sliderValue}px` }} placeholder="Enter the source text here." value={orignalText} onChange={(e) => this.handleSummery(e)} />
                                        </div>
                                        {ShowWordCountForCommandType.includes(commandType) && <div className={totalWords < WordsMaxLength ? "summarize-count summarize-count-font" : "summarize-count summarize-count-color summarize-count-font"}>
                                            <span className="current">{totalWords}</span>
                                            <span className="maximum">/{WordsMaxLength} Words &nbsp;</span>
                                        </div>
                                        }
                                        <div className="authoring-gpt-summery-zoom-wrapper">
                                            <span className="documentzoomPercentagebutton">{sliderValue}px</span>
                                            <button className="documentAiViewerbutton zoomOut" style={{ width: "25px" }} onClick={e => this.handleZoomButtonOnClick('decrement')}></button>
                                            <div className="doc-preview-zoom-inner">
                                                <input style={{ marginTop: "14px" }} type="range" value={sliderValue} onChange={e => this.onRangeValueChange(e)} min="10" max="20" step="1" className="slider" id="myRange" />
                                            </div>
                                            <button className="documentAiViewerbutton zoomIn" style={{ width: "25px" }} onClick={e => this.handleZoomButtonOnClick('increment')}></button>
                                        </div>
                                    </div>
                                    <div className="authoring-gpt-summery-comment-send-save-notebook-wrapper">
                                        <div className="authoring-gpt-command-label">
                                            <span>Command</span>
                                            <button title="Command Expand" class="btn-like-expandAll" onClick={e => {
                                                this.handleOnClickcommandTextExpand()
                                            }}><img src={expandAllBlueIcon} alt="Expand" />
                                            </button>
                                        </div>
                                        <div className="authoring-gpt-command-dropdown-panel-wrapper">
                                            <div className="authoring-GPT-summery-comment-send">
                                                <div className="authoring-comment-gtp-panel">
                                                    <textarea name="commandText" value={commandText} onChange={(e) => this.handleComment(e)} placeholder="Type Additional Commands here." />
                                                    <span title="Save Command" className="add-to-command-action-text add-to-command-gpt-action-save add-to-command-action-gpt" onClick={() => this.handleAddToCommand()}>Save Command</span>
                                                </div>
                                                <div className="authoring-send-gtp-panel">
                                                    <div className="authoring-gtp-add-to-command">
                                                        <span title="My Commands" className="add-to-command-user-template add-to-command-action-gpt" onClick={() => this.handleClickOnMyCommand()}>My Commands</span>
                                                        <span title="Template Commands" className="add-to-command-user-template add-to-command-action-gpt" onClick={() => this.handleClickOnTemplateCommand()}>Template Commands</span>
                                                    </div>
                                                    <select
                                                        className="authoring-gpt-command-dropdown"
                                                        onChange={this.handleChangeCommandType}
                                                        value={commandType}>
                                                        <option value="UserInstructions">User Instructions​</option>
                                                        <option value="CreateTable">Create Table​</option>
                                                        <option value="Summarize">Summarize</option>
                                                        <option value="Translate">Translate</option>
                                                        {/* <option value="QnA">QnA</option> */}
                                                    </select>
                                                    <button className="btnNotebook btn-authoring-summery-gpt" type="button" onClick={(e) => this.onSummeryClick()}>Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="authoring-gpt-right">
                                    <div className="authoring-gpt-summery-result-wrapper">
                                        <div className="authoring-gpt-result-label">
                                            <span>Results</span>
                                        </div>
                                        <div className="authoring-gpt-result-panel">
                                            {this.renderChatConversation()}
                                        </div>
                                    </div>
                                    <div className="authoring-gpt-summery-citation-wrapper">
                                        <div className="authoring-gpt-citation-label">
                                            <span>Citation</span>
                                        </div>
                                        <div className="authoring-gpt-summery-citation-send">
                                            {isCitationProcessing ? <>
                                                <div style={{ textAlign: "center", marginBottom: "10px" }}>
                                                    <img src={imsLoader} alt="Loading Filters" style={{ width: "10%" }} />
                                                </div>
                                            </> : <>
                                                <textarea name="citationText" value={citationText} placeholder="Enter your citation here." onChange={(e) => this.handleCitation(e)} />
                                                <div className="add-to-citation-action-text add-to-command-gpt-action-save add-to-command-action-gpt">
                                                    <span className="authoring-summery-gpt-citation-link" title="Convert Citation" onClick={() => this.handleAddToConvertCitation()}>Convert Citation</span>
                                                    <span className="authoring-summery-citation-seprater"></span>
                                                    <span className="authoring-summery-gpt-citation-link" title="Clear Citation" onClick={this.handleOnClickClearCitationExpand}>Clear Citation</span>
                                                </div>
                                            </>}

                                        </div>
                                    </div>
                                    <div className="authoring-gpt-summery-comment-save-notebook">
                                        <div className="authoring-summery-btn-expand-notebook authoring-summery-gpt-btn-expand-notebook">
                                            {/* <button className="btnNotebook btn-authoring-gpt" type="button" onClick={(e) => this.onNotebookClick()}  >Save to Notebook</button> */}
                                            <div className="authoring-summery-select-notebook">
                                                <div className="authoring-summery-select-notebook-btn">
                                                    <button className="btnSelectNotebook" type="button" onClick={(e) => this.onNotebookClick()}>Select Notebook</button>
                                                </div>
                                                <div className="authoring-summery-select-notebook-txt">
                                                    <input type="text" value={selectedNotebookName} placeholder="Selected Notebook" className="txtSelectNotebook" disabled="true" />
                                                    <div className="authoring-summery-citation-link authoring-summery-gpt-citation-left-link">
                                                        <button type="button" className="authoring-summery-gpt-citation-link" onClick={this.handleOnClicNotesExpand}>Add Notes</button>
                                                        <span className="authoring-summery-citation-seprater"></span>
                                                        <button type="button" className="authoring-summery-gpt-citation-link" onClick={this.handleOnClickClearNotesExpand}>Clear Notes</button>
                                                    </div>
                                                </div>
                                                <div className="authoring-summery-btn-restart authoring-summery-btn-gpt-restart">
                                                    <button disabled={isProcessing || isMultiQuestionProcessing || isCitationProcessing} type="button" className="btn-authoring-reset btn-authoring-gpt btn-authoring-gpt-btn-clearall" onClick={(e) => this.onResetClick()} title="Clear All Fields">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 11.724 13.727">
                                                            <g id="ic_forward_30_24px" transform="translate(0.25 0.57)">
                                                                <path id="ic_forward_30_24px-2" data-name="ic_forward_30_24px" d="M4,8.744a5.417,5.417,0,0,0,5.612,5.163,5.417,5.417,0,0,0,5.612-5.163h-1.4a4.063,4.063,0,0,1-4.209,3.872A4.063,4.063,0,0,1,5.4,8.744,4.063,4.063,0,0,1,9.612,4.872V7.454l3.507-3.227L9.612,1V3.581A5.417,5.417,0,0,0,4,8.744Z" transform="translate(-4 -1)" fill="#ffffff" stroke="#0074B0" stroke-width="0.5" />
                                                            </g>
                                                        </svg>
                                                        <span>Clear All Fields</span>
                                                    </button>
                                                    <button className="btnExpandAllFields btn-authoring-gpt btn-authoring-gpt-btn-expandall" type="button" onClick={(e) => this.onExpandAllFieldsClick()}>
                                                        <img src={globalExpandAllIcon} alt="" width={14} style={{ marginRight: "5px" }} />Expand All Fields</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div></>
                        }
                    </div>)}
            </Dropzone>
            {showNotebookList &&
                <NotebookListPopUpGlobal showModal={showNotebookList} sourceItem={{}} summeryText={savingOrignalText} sessionID={sessionID}
                    summarizeText={savingSummarizeText} handleClose={this.handleCloseNotebookList} width={this.props.customWidth}
                    commandType={savingCommandType} commandText={savingCommandText} notesText={notesText} citationText={citationText}
                    selectedNotebook={this.state.selectedNotebook} isNewNotebook={this.state.isNewNotebook} selectedNotebookName={this.state.selectedNotebookName}
                    handleSelectedNotebook={this.handleSelectedNotebook} updateSelectedNotebook={this.updateSelectedNotebook} isFromGlobalFeaturesMenu={isFromGlobalFeaturesMenuForNotebook} />
            }
            {showNotebookPreviewList &&
                <NotebookListPopUp showModal={showNotebookPreviewList} sourceItem={{}} summeryText={savingOrignalText}
                    summarizeText={savingSummarizeText} handleClose={this.handleCloseNotebookList} width={this.props.customWidth}
                    commandType={savingCommandType} commandText={savingCommandText} notesText={notesText} citationText={citationText} />
            }
            {showCommandList && <CommandListPopUp showModal={showCommandList} handleClose={this.handleCloseCommandList}
                width={this.props.customWidth} commandText={commandText} handleAddToCommandText={this.handleAddToCommandText}
                isUserCommand={isUserCommand} isTemplateCommand={isTemplateCommand} isFromGlobalFeaturesMenu={isFromGlobalFeaturesMenu}
            />}
            {expandCitation && <ExpandContentPopUpModal placeholder='Enter your citation here.' content={citationText} showModal={expandCitation} handleSaveContent={this.handleCitationExpand} />}
            {expandNotes && <ExpandContentPopUpModal placeholder='Enter your custom notes here.' content={notesText} showModal={expandNotes} handleSaveContent={this.handleNotesExpand} />}
            {expandSourceText && <ExpandContentPopUpModal placeholder='Enter the source text here.' content={orignalText} showModal={expandSourceText} handleSaveContent={this.handleSourceTextExpand} />}
            {expandAllFields && <ExpandAllFieldsContentPopUpModal sourceText={orignalText} notesText={notesText} resultsText={summarizeText} showModal={expandAllFields} handleSaveContent={this.handleAllFieldsContentExpand} lastCommandType={lastCommandType} />}
            {expandCommand && <ExpandContentPopUpModal placeholder='Enter your command here.' content={commandText} showModal={expandCommand} handleSaveContent={this.handleCommandTextExpand} />}
            {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
            {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
            {this.state.showSuccess && (
                <>
                    <SuccessReadingList
                        display={this.state.showSuccess}
                        handleClose={(status) => this.handleSuccessClose(status)}
                        data={this.state.successMessage}
                        width={this.state.width}
                    />
                    <div className="savemodal-outer-wrapper"></div>
                </>
            )}
            {this.state.showPopupLoader && <Modal
                show={this.state.showPopupLoader}
                size="lg md sm xs"
                centered
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="savePopUp"
                scrollable={true}
            >
                <div style={{ padding: "0 5%" }}>
                    <div style={{ fontSize: "14px", textAlign: "center" }}>
                        <Modal.Body>
                            <img src={imsLoader} alt="" width={100} height={100} />
                            <div className="saveModal-heading" style={{ color: "#0074B0" }}>Please wait while uploading file.</div>
                        </Modal.Body>
                    </div>
                </div>

            </Modal>}
            {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={this.handleDisclaimerClose} />}
            {this.renderModelLoader()}
        </div>)
    }
}
export default AuthoringGPT;